import { ReactNode } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { ArrowLeft } from '@mint-lib/icons';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import { Link as RouterLink } from '@mint/routing';

type PageHeaderProps = {
  title: string;
  description?: string;
  backLink?: boolean;
  children?: ReactNode;
};

export const PageHeader = ({
  title,
  description,
  backLink,
  children,
}: PageHeaderProps) => {
  const { t } = useTranslation('@myn/import-hub');

  return (
    <div id="hub-header-container">
      <div className="mb-4 flex items-start justify-between">
        <div>
          {backLink && (
            <RouterLink
              to=".."
              data-dd-action-name="Back to Data Import Management Hub"
              className={cn(
                typographyVariants({ variant: 'bodyShort02' }),
                'mb-3 flex items-center gap-2 fill-text-link text-text-link',
              )}
            >
              <ArrowLeft className="size-4" />
              {t('Back to Data Import Management Hub')}
            </RouterLink>
          )}
          <h2 className={cn(typographyVariants({ variant: 'h2' }), 'mb-2')}>
            {title}
          </h2>
          <p
            className={cn(
              typographyVariants({ variant: 'bodyShort01' }),
              'text-text-secondary',
            )}
          >
            {description}
          </p>
        </div>
        {children}
      </div>
    </div>
  );
};
